import { DateTimePipe } from '../../shared/pipes/date-time.pipe';

export function dateTime ( dateTimePipe : DateTimePipe ) {
  // As of now, this filter assumes input in the format
  // of 'YYYY-MM-DDThh:mm:ss.XXXZ'.
  return ( value : string ) : string => dateTimePipe.transform(value);
};